import logger from 'shared/services/logger'
import store from 'shared/store'
import { hasResults } from 'shared/utils/algolia/resultsState'
import AlgoliaInstantSearchContainer from 'views/containers/browser/AlgoliaInstantSearchContainer'
import hydrateWithHOCs from 'views/containers/browser/utils/hydrateWithHOCs'
import { pushSetupPreloadedSlotsCommand } from 'views/utils/adServerUtils'

export default async ({ container, i18n }) => {
  logger.info('Algolia search components loaded')

  const {
    pageProperties,
    publicConfig,
    publicConfig: { tenant },
  } = store.getPublicRuntimeConfig()

  if (!hasResults(pageProperties.resultsState)) {
    return
  }

  await hydrateWithHOCs({
    container,
    i18n,
  })(
    <AlgoliaInstantSearchContainer
      tenant={tenant}
      publicConfig={publicConfig}
      pageProperties={pageProperties}
    />
  )

  // In some cases we might get DOM mismatch between what's on the page and
  // hydrated component (because other script changed DOM) and hydration will
  // throw away existing DOM nodes, including our attached events.
  pushSetupPreloadedSlotsCommand(container)
}
